enum OrderStatusEnum {
  Cancelled = 'Cancelled',
  Complete = 'Complete',
  OnReferral = 'On-Referral',
  Pending = 'Outstanding',
  TrackOrder = 'Track order',
}

export default OrderStatusEnum;
